var _path, _circle, _path2, _path3, _circle2, _circle3, _circle4, _circle5, _path4, _line, _line2, _rect, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _path5, _circle6, _circle7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoLongFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3 100 C 40 60, 100 30, 200 30 L 200 170 C 100 170, 40 140, 3 100 Z",
    strokeWidth: 3,
    fill: "#aaa",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    cx: 120,
    cy: 100,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 103 110 L 110 110 L 110 90 L 103 90 ",
    strokeWidth: 3,
    fill: "transparent",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 105 100 L 75 100",
    strokeWidth: 3,
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 108,
    cy: 54,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 132,
    cy: 48,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 108,
    cy: 146,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 132,
    cy: 152,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 95 43 L 95 157 C 80 140, 80 60, 95 43",
    strokeWidth: 1.5,
    stroke: "black",
    fill: "transparent"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 90,
    x2: 65,
    y2: 98,
    strokeWidth: 2,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 110,
    x2: 70,
    y2: 105,
    strokeWidth: 2,
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 40,
    width: 15,
    height: 120,
    strokeWidth: 2,
    stroke: "black",
    fill: "transparent"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 40,
    x2: 150,
    y2: 160,
    stroke: "black"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 40,
    x2: 155,
    y2: 160,
    stroke: "black"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 40,
    x2: 160,
    y2: 160,
    stroke: "black"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 50,
    x2: 160,
    y2: 50,
    stroke: "black"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 60,
    x2: 160,
    y2: 60,
    stroke: "black"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 70,
    x2: 160,
    y2: 70,
    stroke: "black"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 80,
    x2: 160,
    y2: 80,
    stroke: "black"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 90,
    x2: 160,
    y2: 90,
    stroke: "black"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 100,
    x2: 160,
    y2: 100,
    stroke: "black"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 110,
    x2: 160,
    y2: 110,
    stroke: "black"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 120,
    x2: 160,
    y2: 120,
    stroke: "black"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 130,
    x2: 160,
    y2: 130,
    stroke: "black"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 140,
    x2: 160,
    y2: 140,
    stroke: "black"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 150,
    x2: 160,
    y2: 150,
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 198 40 L 180 40 L 170 80 L 170 120 L 180 160 L 198 160",
    strokeWidth: 2,
    stroke: "black",
    fill: "transparent"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    cx: 200,
    cy: 70,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    cx: 200,
    cy: 130,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoLongFront);
export default __webpack_public_path__ + "static/media/TwoLongFront.8c20eb5efdfd574d1eed9abeb5a8300d.svg";
export { ForwardRef as ReactComponent };